module.exports = "/_next/static/images/817a7923372388516d64480836f3c08c-nu-fifa-logo@2x.png.webp";